import { useState, useEffect } from 'react';
import type { User } from 'firebase/auth';
import { AuthService } from '../services/auth.service';
import { ADMIN_EMAIL_DOMAINS } from '@campusmeds/shared';

export interface UseAuthReturn {
  user: User | null;
  loading: boolean;
  isAdmin: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export function useAuth(): UseAuthReturn {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = AuthService.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const isAdmin = user?.email
    ? ADMIN_EMAIL_DOMAINS.some(domain => user.email!.includes(domain))
    : false;

  const signIn = async (email: string, password: string): Promise<void> => {
    await AuthService.signIn(email, password);
  };

  const signUp = async (email: string, password: string): Promise<void> => {
    await AuthService.signUp(email, password);
  };

  const signOut = async (): Promise<void> => {
    await AuthService.signOut();
  };

  return {
    user,
    loading,
    isAdmin,
    signIn,
    signUp,
    signOut
  };
}